import FieldsListPanel from './FieldsListPanel';

export default FieldsListPanel;